<template>
  <v-app id="inspire">
    <component :is="layout">
      <router-view :key="$route.fullPath"></router-view>
    </component>
    <!-- <confirm ref="confirm" style="z-index: 99999;"></confirm> -->
    <!-- <v-snackbar v-model="snackbar_status" :color="snackbar_color" :timeout="6000" :top="snackbar_top" :left="snackbar_left" :right="snackbar_right" style="z-index: 999999;">
        {{ snackbar_msg }}
        <v-btn flat @click="snackbar_status = false">
            Close
        </v-btn>
    </v-snackbar>         -->
    <v-snackbar top v-model="snackbar.saveError" color="red accent-2">{{snackbar.errorMessage}}</v-snackbar>
    <v-snackbar top v-model="snackbar.saveSuccess" color="green">{{snackbar.successMessage}}</v-snackbar>

  </v-app>
</template>
<script>
const default_layout = "layout-default"

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout)
    },
    snackbar() {
      return this.$store.state.snackbar
    }
  },
  created() {

  }
}
</script>

<style>
.compact-form {
    transform: scale(0.875);
    transform-origin: left;
    /* zoom: 0.875;
    transform-origin: left; */
}
.new-compact-form {
    zoom: 0.875;
}

.small-table .v-data-table__wrapper {
  font-size: 12px !important; /* Smaller text */
}

.small-table .v-data-table {
  padding: 8px !important; /* Reduce padding */
}

.small-table .v-data-table__row {
  height: 24px !important; /* Reduce row height */
}

.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  background-color: transparent !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.spreadsheet-input .v-input__slot {
    background-color: #ffe169 !important;
    text-align: center;
}

.spreadsheet-cell .v-text-field.v-text-field--solo .v-input__control input {
  text-align: center !important;
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow: hidden;
}

.flex-table {
  display: flex;
  flex-grow: 1;
  width: 100%;
}

.flex-table > div {
  width: 100%;
}

.disable-input input {
  padding: 0 !important;
  border: none;
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__control {
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__slot {
  background-color: #E0E0E0 !important;
}

.disable-input ::v-deep .v-input__control input {
  background-color: #E0E0E0 !important;
}

.disable-input .v-input__slot {
    background-color: #E0E0E0 !important;
}

.disable2-input input {
  padding: 0 !important;
  border: none;
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__control {
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__slot {
  background-color: #F5F5F5 !important;
}

.disable2-input ::v-deep .v-input__control input {
  background-color: #F5F5F5 !important;
}

.disable2-input .v-input__slot {
    background-color: #F5F5F5 !important;
}
</style>
